module.exports = __webpack_public_path__ + "img/goodfirms-award.8ec4c650.png";